import React from "react";
import { Link } from "react-router-dom";
import { FiPhone, FiMail, FiMapPin, FiHeart } from "react-icons/fi";

function Footer() {
  return (
    <footer className="site-footer mt-auto">
      <div className="container">
        <div className="footer-main">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
              <div className="footer-brand">
                <Link to="/">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/eluminous-pvt-ltd.png"
                    }
                    alt="eLuminous Technologies"
                    className="footer-logo"
                  />
                </Link>
                <p className="footer-desc">
                  Empowering our team with the tools and resources to grow,
                  collaborate, and thrive together.
                </p>
              </div>
            </div>
            <div className="col-xl-2 offset-xl-1 col-lg-2 col-md-6 col-sm-6 mb-4">
              <h6 className="footer-heading">Quick Links</h6>
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                {/* <li>
                  <Link to="/careers">Careers</Link>
                </li> */}
                <li>
                  <Link to="/holiday">Holidays</Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 mb-4">
              <h6 className="footer-heading">Resources</h6>
              <ul className="footer-links">
                <li>
                  <Link to="/business-communication">Training</Link>
                </li>
                <li>
                  <Link to="/login">Employee Login</Link>
                </li>
                <li>
                  <Link to="/technologies">Technologies</Link>
                </li>
              </ul>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
              <h6 className="footer-heading">Contact</h6>
              <ul className="footer-contact">
                <li>
                  <FiPhone className="footer-contact-icon" />
                  <div>
                    <a href="tel:14844019147">USA: +1 484 401 9147</a>
                  </div>
                </li>
                <li>
                  <FiPhone className="footer-contact-icon" />
                  <div>
                    <a href="tel:912532382566">India: +91 253 238 2566</a>
                    <span className="footer-contact-sep"> / </span>
                    <a href="tel:918208222939">8208222939</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            Copyright © 2003 – {new Date().getFullYear()}{" "}
            <Link
              to="https://eluminoustechnologies.com/"
              target="_blank"
              className="footer-company-link"
            >
              eLuminous Technologies Pvt. Ltd.
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
